import Back from './Back';
import Name from './Name';
import Status from './Status';
import Contact from './Contact';
import Issue from './Issue';
import Permissions from './Permissions';
import Pane from '../../components/Pane';
import List from '../../components/List';
import Menu from '../../components/Menu';
import { useParams } from 'react-router-dom';
import { useState, Fragment } from 'react';
import { useMediaQuery } from 'react-responsive';
import Dot from '../../components/Dot';
import { ReactComponent as HamburgerIcon } from '../../../../../icons/icon-hamburger.svg';
import { useCallback } from 'react';
import { useEffect } from 'react';
import { selectBrokerProducts } from '../../../../../store/selectors/brokerProducts';
import { useSelector } from 'react-redux';
import { slugify } from '../../Products/helpers';
import { selectProduct } from '../../../../..//store/selectors/products';

const Sidebar = () => {
  const brokerProducts = useSelector(selectBrokerProducts);
  const brokerProduct = useSelector(selectProduct);
  const { product } = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const [styleToggleButton, setMenuStyle] = useState({});

  const hasOneProduct = brokerProducts?.data.length === 1;
  const {
    data: { name },
  } = brokerProduct;

  const toggleSidebar = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  const isTablet = useMediaQuery({
    query: '(max-width: 768px)',
  });

  useEffect(() => {
    if (isOpen) {
      setMenuStyle({
        transform: 'translateX(0)',
        position: 'fixed',
        bottom: '0',
        background: 'white',
        padding: '12px',
        width: '95%',
        top: '248px',
        left: '0',
        overflowY: 'auto',
        zIndex: 9,
      });

      document.body.classList.add('is-overflow-hidden');
    } else {
      setMenuStyle({
        transform: 'translateX(-100%)',
        position: 'fixed',
        left: 0,
      });

      document.body.classList.remove('is-overflow-hidden');
    }
  }, [isOpen]);

  useEffect(() => {
    const link = document.querySelectorAll('.integration__menu a');

    isTablet &&
      link.forEach((element) => {
        element.addEventListener('click', () => {
          toggleSidebar();
          setMenuStyle({
            transform: 'translateX(-100%)',
            position: 'fixed',
            left: 0,
          });

          document.body.classList.remove('is-overflow-hidden');
        });
      });
  }, [isOpen]);

  return (
    <Fragment>
      {isTablet && (
        <Dot onCallback={toggleSidebar}>
          <HamburgerIcon />
        </Dot>
      )}

      <div style={isTablet ? styleToggleButton : {}}>
        {!hasOneProduct ? <Back /> : null}

        <Pane>
          <List direction='column'>
            <Name />
            <Status />
          </List>
        </Pane>

        <Pane>
          <List direction='column'>
            <Menu
              items={[
                {
                  labeli18n: 'Integration details',
                  url: `/integrations/${slugify(product)}/details?product=${name}`,
                },
                {
                  labeli18n: 'Ready plugins',
                  url: `/integrations/${slugify(product)}/plugins?product=${name}`,
                },
              ]}
            />
          </List>
        </Pane>

        <Pane>
          <Permissions />
        </Pane>

        <Pane>
          <Issue />
        </Pane>

        <Pane color='grey' padding='none'>
          <Contact />
        </Pane>
      </div>
    </Fragment>
  );
};

export default Sidebar;
